module.exports = __webpack_public_path__ + "static/media/karl.8567307a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard/contact/karl.png
// module id = 1493
// module chunks = 0